import axios from 'axios';
import { ILogo } from 'src/infrastructure/interfaces';

export default class LogoService {

  static createLogo(title: string, imageFormData: FormData) {

    return new Promise((resolve, reject) => {
      axios
        .post('/logoUpload',
              imageFormData,
              { headers: {'Content-Type': 'multipart/form-data' }})
        .then((res) => {
          const image = res.data.file;
              axios
                .post('/logos', { title, image })
                .then((res) => {
                  resolve(res.data);
                })
            })
        .catch(error => reject(error));
    });
  }

  static updateLogo(id: number, title: string, imageFormData?: FormData) {
    
    if (imageFormData) {

      return new Promise((resolve, reject) => {
        axios
          .post('/logoUpload',
                imageFormData,
                { headers: {'Content-Type': 'multipart/form-data' }})
          .then((res) => {
                const image = res.data.file;
                axios
                  .put('/logos', { id, title, image })
                  .then((res) => {
                    resolve(res.data);
                  })
            })
          .catch(error => reject(error));
      });
    } else {

      return new Promise((resolve, reject) => {
        axios
          .put('/logos', { id, title })
          .then((res) => {
            resolve(res.data);
          })
          .catch(error => reject(error));
      });
    }
  }

  static deleteLogo(id: number) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/logos/${id}`)
        .then((res) => {
          resolve(id);
        })
        .catch(error => reject(error));
    });
  }

  static archiveLogo(logo: ILogo) {
    const logoArchived = {...logo, archived: true}
    return new Promise((resolve, reject) => {
      axios
        .put(`/logos/${logo.id}`, logoArchived)
        .then((res) => {
          resolve(logoArchived);
        })
        .catch(error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/LogoService.ts